import { styled, Box } from '@mui/material';
import { BRAND_GRADIENT } from '@presentation/styling/gradients';

export const Wrapper = styled(Box)(({ theme }) => ({
	background: BRAND_GRADIENT,
	borderRadius: 16,
	position: 'relative',
	overflow: 'hidden',
	border: `1px solid ${theme.colors.border}`,
	minHeight: 100,
	cursor: 'pointer',
	[theme.breakpoints.up('md')]: {
		minHeight: 234,
		aspectRatio: '1/1',
	},
}));

export const CardImage = styled('img')(() => ({
	position: 'absolute',
	top: 0,
	left: 0,
	width: '100%',
	height: '100%',
	objectFit: 'cover',
	zIndex: 0,
}));

export const TextWrapper = styled(Box)(() => ({
	position: 'absolute',
	zIndex: 2,
	bottom: 20,
	left: 30,
	cursor: 'pointer',
}));

export const Overlay = styled('div')(() => ({
	position: 'absolute',
	top: 0,
	left: 0,
	width: '100%',
	height: '100%',
	zIndex: 1,
	borderRadius: '16px',
	background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 50%);',
}));
